export default "__VITE_ASSET__B4fem$T9__"